import styled, { keyframes } from 'styled-components';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { BASE } from 'design-system/variables/spacing';

const DashboardRegisterActivateView = () => {
  return (
    <Container>
      <LoadingIndicator />
      Setting up your account...
    </Container>
  );
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${BASE * 10}px;
  animation: ${fadeIn} 1s;
`;

export default DashboardRegisterActivateView;
